module.exports = __webpack_public_path__ + "static/img/logo3.64935b12.png";